const RecycleIcon = (props: { width?: number; height?: number; fill?: string; stroke?: string }) => {
  const { width = 20, height = 20, fill = 'none', stroke = 'none' } = props
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill={fill}
      stroke={stroke}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.1303 9.66594L17.4062 11.8759C18.212 13.2709 17.7337 15.0551 16.3395 15.8601C15.8953 16.1159 15.3928 16.2509 14.8812 16.2509H13.162V17.9176L8.99533 15.0009L13.162 12.0843V13.7509H14.8803C14.9537 13.7509 15.0253 13.7318 15.0887 13.6951C15.2662 13.5926 15.3395 13.3801 15.2728 13.1943L15.2412 13.1259L13.9653 10.9159L16.1303 9.66594ZM6.27616 7.40427L6.71783 12.4709L5.27616 11.6376L4.41616 13.1259C4.37949 13.1893 4.36033 13.2609 4.36033 13.3343C4.36033 13.5384 4.50783 13.7093 4.70199 13.7443L4.77699 13.7509H7.32866V16.2509H4.77699C3.16616 16.2509 1.86033 14.9451 1.86033 13.3343C1.86033 12.8226 1.99533 12.3193 2.25116 11.8759L3.11033 10.3876L1.66699 9.55427L6.27533 7.40427H6.27616ZM11.287 2.05844C11.7303 2.31427 12.0987 2.68261 12.3545 3.12594L13.2128 4.61427L14.657 3.78094L14.2153 8.84761L9.60533 6.69761L11.0487 5.86427L10.1895 4.37594C10.1528 4.31261 10.1003 4.25927 10.037 4.22344C9.85949 4.12094 9.63866 4.16344 9.51116 4.31511L9.46783 4.37594L8.19282 6.58594L6.02699 5.33594L7.30199 3.12594C8.10783 1.73094 9.89199 1.25261 11.287 2.05844Z"
        fill="white"
      />
    </svg>
  )
}

export default RecycleIcon
